import { PaymentIntentStatus } from '@prisma/client';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

type PaymentIntent = {
  id: string;
  affiliateFirmId: string;
  companyId: number;
  serviceRequestId: string | null;
  status: PaymentIntentStatus;
  collectedAt: string | null;
  collectedBy: string | null;
  createdAt: string;
  updatedAt: string;
  company?: { companyDisplayName: string | null };
};

export function useAffiliatePaymentIntents(
  affiliateFirmId: string | null,
  filters?: { status?: PaymentIntentStatus }
) {
  const params = new URLSearchParams();
  if (filters?.status) params.set('status', filters.status);
  const queryString = params.toString();

  const {
    data,
    error,
    mutate,
  }: {
    data?: { paymentIntents: PaymentIntent[] };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    affiliateFirmId
      ? `affiliate-firms/${affiliateFirmId}/payment-intents${queryString ? `?${queryString}` : ''}`
      : null,
    SWRFetcher({ method: 'GET' })
  );

  return { data, error, mutate };
}
